import { instanceApi } from '@/services/ProviderService'

export default {
    getEmployee(usercode){
        return instanceApi().get(`/api/employee/${usercode}`).then(res => res.data);
    },
    getTransport() {
        return instanceApi().get(`/api/transports`).then(res => res.data);        
    }
}
